import React, { useState, useEffect, useContext } from "react";
import {
  ButtonBase,
  PickerSelectSimple,
  PickerCheckboxSimple,
  ThemeProvider,
  theme,
} from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import {
  payloadToUrl,
  urlToPayload,
  getReservePrices,
  getSortOptions,
  getFilterOptions,
  getAllProperties,
  Context,
} from "services";
import { useRouter } from "next/router";
import SearchSvg2 from "../Icons/SearchSvg2";

export default function AdvanceSearchComponent(props: any) {
  const router = useRouter();
  const [filterObject, setFilterObject] = useState<any>();
  const [propertiesFacets, setPropertiesFacets] = useState<any>();
  const [ready, setReady] = useState<boolean>(false);
  const [refreshAssetList, setRefreshAssetList] = useState<any>();
  const [refreshSubAssetList, setRefreshSubAssetList] = useState<any>();
  const [refreshStateList, setRefreshStateList] = useState<any>();
  const [refreshCityList, setRefreshCityList] = useState<any>();
  const [refreshBankList, setRefreshBankList] = useState<any>();
  const { searchForm }: any = useContext(Context);

  useEffect(() => {
    (async () => {
      setReady(false);
      if (props.urlData) {
        const payload = await urlToPayload(
          props.urlData,
          searchForm,
          props.propertiesFacetsWithoutFilter,
          router,
          {}
        );
        setFilterObject(payload);
        const data: any = await getAllProperties(payload);
        setPropertiesFacets(data.facets);
      }
      setReady(true);
    })();
  }, []);

  const generateDropdownValues = async (formElement: any, query: any) => {
    if (
      searchForm.value.state &&
      !propertiesFacets?.state.find(
        (item: any) => item.slug === searchForm.value.state.value
      )
    ) {
      searchForm.setField("state", "");
    }

    if (
      searchForm.value.city &&
      !propertiesFacets?.city.find(
        (item: any) => item.slug === searchForm.value.city.value
      )
    ) {
      searchForm.setField("city", "");
    }

    if (
      searchForm.value.institutes &&
      !propertiesFacets?.bank.find(
        (item: any) => searchForm.value.institutes.value === item.slug
      )
    ) {
      searchForm.setField("institutes", "");
    }

    let filteredData;
    switch (formElement) {
      case "asset_type":
        if (
          router.query.start_from === "asset-type" &&
          searchForm.value.asset_type
        ) {
          filteredData = props.propertiesFacetsWithoutFilter?.asset.map(
            (item: any) => {
              return { value: item.slug, label: item.name };
            }
          );
        } else if (searchForm.value.asset_type) {
          filteredData = props.propertiesFacetsWithoutFilter?.asset.map(
            (item: any) => {
              return { value: item.slug, label: item.name };
            }
          );
        } else {
          filteredData = propertiesFacets?.asset.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        }
        break;
      case "sub_asset_type":
        if (searchForm.value.asset_type && searchForm.value.sub_asset_type) {
          const data: any = await getAllProperties({
            apiConfig: {
              includeRelations: ["city", "sub_asset_type", "bank"],
              includeMutations: ["state", "asset"],
              includeFacets: true,
            },
            limitBy: {
              per_page: 9,
              page: 1,
            },
            sortBy: [],
            filterBy: [
              {
                attribute: "asset-type",
                value: [searchForm.value.asset_type.value],
              },
              {
                attribute: "status",
                op: "eq",
                value: "active",
              },
            ],
          });
          filteredData = data.facets?.sub_asset_type.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        } else {
          filteredData = propertiesFacets?.sub_asset_type.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        }
        break;
      case "state":
        if (searchForm.value.sub_asset_type && searchForm.value.state) {
          const data: any = await getAllProperties({
            apiConfig: {
              includeRelations: ["city", "sub_asset_type", "bank"],
              includeMutations: ["state", "asset"],
              includeFacets: true,
            },
            limitBy: {
              per_page: 9,
              page: 1,
            },
            sortBy: [],
            filterBy: [
              {
                attribute: "sub-asset-type",
                value: [searchForm.value.sub_asset_type.value],
              },
              {
                attribute: "status",
                op: "eq",
                value: "active",
              },
            ],
          });
          filteredData = data.facets?.state.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        } else if (searchForm.value.sub_asset_type) {
          const data: any = await getAllProperties({
            apiConfig: {
              includeRelations: ["city", "sub_asset_type", "bank"],
              includeMutations: ["state", "asset"],
              includeFacets: true,
            },
            limitBy: {
              per_page: 9,
              page: 1,
            },
            sortBy: [],
            filterBy: [
              {
                attribute: "sub-asset-type",
                value: [searchForm.value.sub_asset_type.value],
              },
              {
                attribute: "status",
                op: "eq",
                value: "active",
              },
            ],
          });
          filteredData = data.facets?.state.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        } else if (searchForm.value.asset_type) {
          const data: any = await getAllProperties({
            apiConfig: {
              includeRelations: ["city", "sub_asset_type", "bank"],
              includeMutations: ["state", "asset"],
              includeFacets: true,
            },
            limitBy: {
              per_page: 9,
              page: 1,
            },
            sortBy: [],
            filterBy: [
              {
                attribute: "asset-type",
                value: [searchForm.value.asset_type.value],
              },
              {
                attribute: "status",
                op: "eq",
                value: "active",
              },
            ],
          });
          filteredData = data.facets?.state.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        } else if (
          router.query.start_from === "location" &&
          router.query.state
        ) {
          filteredData = props.propertiesFacetsWithoutFilter?.state.map(
            (item: any) => {
              return { value: item.slug, label: item.name };
            }
          );
        } else {
          filteredData = propertiesFacets?.state.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        }
        break;
      case "city":
        if (searchForm.value.state && searchForm.value.city) {
          const data: any = await getAllProperties({
            apiConfig: {
              includeRelations: ["city", "sub_asset_type", "bank"],
              includeMutations: ["state", "asset"],
              includeFacets: true,
            },
            limitBy: {
              per_page: 9,
              page: 1,
            },
            sortBy: [],
            filterBy: [
              {
                attribute: "state",
                value: [searchForm.value.state.value],
              },
              {
                attribute: "status",
                op: "eq",
                value: "active",
              },
            ],
          });
          filteredData = data.facets?.city.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        } else {
          filteredData = propertiesFacets?.city.map((item: any) => {
            return { value: item.slug, label: item.name };
          });
        }
        break;
      case "institutes":
        filteredData = propertiesFacets?.bank.map((item: any) => {
          return { value: item.slug, label: item.name };
        });
        break;
      default:
        break;
    }

    if (query) {
      const filterOptions = filteredData.filter(
        (option: any) =>
          option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
      );

      return filterOptions;
    } else {
      return filteredData;
    }
  };

  const updateData = async (value: any) => {
    const data: any = await getAllProperties(value);
    setPropertiesFacets(data.facets);
  };

  const handleAssetOnChange = async (value: any) => {
    searchForm.setField("asset_type", value);
    searchForm.setField("sub_asset_type", "");

    setFilterObject((prev: any) => {
      prev.filterBy = prev.filterBy.map(
        (obj: any) =>
          [
            {
              attribute: "asset-type",
              value: [value.value],
            },
          ].find((newObj) => newObj.attribute === obj.attribute) || obj
      );
      if (prev.filter_by === undefined) {
        prev.filterBy = [
          {
            attribute: "asset-type",
            value: [value.value],
          },
        ];
      }
      updateData(prev);
      return prev;
    });
  };

  const handleSubAssetOnChange = (value: any) => {
    searchForm.setField("sub_asset_type", value);
    setFilterObject((prev: any) => {
      prev.filterBy = prev.filterBy.map(
        (obj: any) =>
          [
            {
              attribute: "sub-asset-type",
              value: [value.value],
            },
          ].find((newObj) => newObj.attribute === obj.attribute) || obj
      );
      updateData(prev);
      return prev;
    });
  };

  const handleStateOnChange = (value: any) => {
    searchForm.setField("state", value);
    searchForm.setField("city", "");

    setFilterObject((prev: any) => {
      prev.filterBy = prev.filterBy.map(
        (obj: any) =>
          [
            {
              attribute: "state",
              value: [value.value],
            },
          ].find((newObj) => newObj.attribute === obj.attribute) || obj
      );

      if (prev.filter_by === undefined) {
        prev.filterBy = [
          {
            attribute: "state",
            value: [value.value],
          },
        ];
      }

      updateData(prev);
      return prev;
    });
  };

  const handleCityOnChange = (value: any) => {
    searchForm.setField("city", value);
    setFilterObject((prev: any) => {
      prev.filterBy = prev.filterBy.map(
        (obj: any) =>
          [
            {
              attribute: "city",
              value: [value.value],
            },
          ].find((newObj) => newObj.attribute === obj.attribute) || obj
      );

      updateData(prev);
      return prev;
    });
  };

  useEffect(() => {
    setRefreshSubAssetList(new Date().getTime());
    setRefreshStateList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
    setRefreshBankList(new Date().getTime());
  }, [searchForm.value.asset_type && propertiesFacets]);

  useEffect(() => {
    setRefreshStateList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
    setRefreshBankList(new Date().getTime());
  }, [searchForm.value.sub_asset_type && propertiesFacets]);

  useEffect(() => {
    setRefreshAssetList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
    setRefreshBankList(new Date().getTime());
  }, [searchForm.value.state && propertiesFacets]);

  useEffect(() => {
    setRefreshAssetList(new Date().getTime());
    setRefreshSubAssetList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
    setRefreshBankList(new Date().getTime());
  }, [searchForm.value.city && propertiesFacets]);

  const handleSubmit = () => {
    payloadToUrl(router, searchForm.value);
    props.onAction("no");
  };

  const newTheme = {
    ...theme,
    variants: {},
  };

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div className="flex justify-between bg-gray-50 items-center px-4 py-3 border-b text-lg text-gray-900 font-medium">
            <div>Advance Search</div>
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          {ready ? (
            <>
              <div className="p-4 border-b-2 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-5">
                <div>
                  <PickerSelectSimple
                    refresh={refreshAssetList}
                    dataSource={async (c) => {
                      return generateDropdownValues("asset_type", c);
                    }}
                    defaultString="Select property type"
                    defaultSelected={
                      searchForm.getField("asset_type") !== ""
                        ? [searchForm.getField("asset_type")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Property type",
                      labelBaseClasses: {
                        font: "text-base font-medium leading-6",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-base leading-6 text-gray-400",
                        spanBaseClasses: "text-base",
                      },
                      optionClasses: {
                        label: "text-lg",
                      },
                    }}
                    onChange={(value: any) => handleAssetOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={false}
                  />
                </div>
                <div>
                  <PickerSelectSimple
                    refresh={refreshSubAssetList}
                    dataSource={async (c) => {
                      return generateDropdownValues("sub_asset_type", c);
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-base leading-6 text-gray-400",
                        spanBaseClasses: "text-base",
                      },
                    }}
                    defaultString="Select property sub type"
                    defaultSelected={
                      searchForm.getField("sub_asset_type") !== ""
                        ? [searchForm.getField("sub_asset_type")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Property sub type",
                      labelBaseClasses: {
                        font: "text-base font-medium leading-6",
                      },
                    }}
                    onChange={(value: any) => handleSubAssetOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={searchForm.value.asset_type ? false : true}
                  />
                </div>
                <div>
                  <PickerSelectSimple
                    refresh={refreshStateList}
                    dataSource={async (c) => {
                      return generateDropdownValues("state", c);
                    }}
                    defaultString="Select state"
                    defaultSelected={
                      searchForm.getField("state") !== ""
                        ? [searchForm.getField("state")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Location",
                      labelBaseClasses: {
                        font: "text-base font-medium leading-6",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-base leading-6 text-gray-400",
                        spanBaseClasses: "text-base",
                      },
                    }}
                    onChange={(value: any) => handleStateOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={false}
                  />
                </div>
                <div>
                  <PickerSelectSimple
                    refresh={refreshCityList}
                    dataSource={async (c) => {
                      return generateDropdownValues("city", c);
                    }}
                    defaultString="Select city"
                    defaultSelected={
                      searchForm.getField("city") !== ""
                        ? [searchForm.getField("city")]
                        : []
                    }
                    labelBaseProps={{
                      label: "City",
                      labelBaseClasses: {
                        font: "text-base font-medium leading-6",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-base leading-6 text-gray-400",
                        spanBaseClasses: "text-base",
                      },
                    }}
                    onChange={(value: any) => handleCityOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={searchForm.value.state ? false : true}
                  />
                </div>
                <div>
                  <PickerSelectSimple
                    dataSource={async (c) => {
                      return getReservePrices();
                    }}
                    enableToggle
                    defaultString="Select price range"
                    defaultSelected={
                      searchForm.getField("reserve_price") !== ""
                        ? [searchForm.getField("reserve_price")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Reserve price",
                      labelBaseClasses: {
                        font: "text-base font-medium leading-6",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-base leading-6 text-gray-400",
                        spanBaseClasses: "text-base",
                      },
                    }}
                    onChange={(value: any) =>
                      searchForm.setField("reserve_price", value)
                    }
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={false}
                    disabled={false}
                  />
                </div>
              </div>
              <div className="p-4 border-b-2">
                <div className="flex flex-col">
                  <div>Institutes</div>
                  <div className="text-xs text-gray-500 font-normal leading-4">
                    Filter properties according to the selected institutes
                  </div>
                </div>

                <div className="overflow-hidden">
                  <PickerCheckboxSimple
                    refresh={refreshBankList}
                    scrollableBaseProps={{
                      scrollableBaseClasses: {
                        position: "z-50 p-2 space-y-1 overflow-y-scroll",
                        maxHeight: "h-20",
                        border: "border-0",
                        background: "bg-white",
                        borderRadius: "",
                      },
                    }}
                    pickerCheckboxSimpleClasses={{
                      optionClasses: {
                        labelBaseClasses: {
                          font: "inter font-normal text-xs leading-5",
                          alignment: "ml-3",
                        },
                      },
                    }}
                    textInputBaseClasses={{
                      focus:
                        "focus:border-gray-500 focus:ring-blue-500 checked:bg-blue-500",
                      textColor: "text-blue-400 dark:text-white",
                    }}
                    multiple={false}
                    name="institutes"
                    valueKey="value"
                    dataSource={(c) => {
                      return generateDropdownValues("institutes", c);
                    }}
                    defaultSelected={
                      searchForm.getField("institutes") !== ""
                        ? [searchForm.getField("institutes")]
                        : []
                    }
                    onChange={(v: any) => {
                      searchForm.setField("institutes", v);
                    }}
                  />
                </div>
              </div>
              <div className="p-4 border-b-2 ">
                <div className="flex flex-col">
                  <div>Filter by</div>
                  <div className="text-xs text-gray-500 font-normal leading-4">
                    Filter properties across auction bazaar database
                  </div>
                </div>
                <div>
                  <div>
                    <PickerCheckboxSimple
                      scrollableBaseProps={{
                        scrollableBaseClasses: {
                          position:
                            "z-50 block space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10",
                          maxHeight: "",
                          border: "border-0",
                          background: "bg-white",
                          borderRadius: "",
                        },
                      }}
                      textInputBaseClasses={{
                        focus:
                          "focus:border-gray-500 focus:ring-blue-500 checked:bg-blue-500",
                        textColor: "text-blue-400 dark:text-white",
                      }}
                      pickerCheckboxSimpleClasses={{
                        optionClasses: {
                          labelBaseClasses: {
                            font: "inter font-normal text-xs leading-5",
                            alignment: "ml-3",
                          },
                        },
                      }}
                      multiple={false}
                      name="filter_by"
                      valueKey="value"
                      dataSource={() => {
                        return getFilterOptions();
                      }}
                      defaultSelected={
                        searchForm.getField("filter_by") !== ""
                          ? [searchForm.getField("filter_by")]
                          : []
                      }
                      onChange={(v: any) => searchForm.setField("filter_by", v)}
                    />
                  </div>
                </div>
              </div>
              <div className="p-4 border-b-2 ">
                <div className="flex flex-col">
                  <div>Sort by</div>
                  <div className="text-xs text-gray-500 font-normal leading-4">
                    Sort properties across auction bazaar database
                  </div>
                </div>
                <div>
                  <div className="">
                    <PickerCheckboxSimple
                      scrollableBaseProps={{
                        scrollableBaseClasses: {
                          position:
                            "z-50 block space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-2",
                          maxHeight: "",
                          border: "border-0",
                          background: "bg-white",
                          borderRadius: "",
                        },
                      }}
                      textInputBaseClasses={{
                        focus:
                          "focus:border-gray-500 focus:ring-blue-500 checked:bg-blue-500",
                        textColor: "text-blue-400 dark:text-white",
                      }}
                      pickerCheckboxSimpleClasses={{
                        optionClasses: {
                          labelBaseClasses: {
                            font: "inter font-normal text-xs leading-5",
                            alignment: "ml-3",
                          },
                        },
                      }}
                      multiple={false}
                      name="sort_by"
                      valueKey="value"
                      dataSource={() => {
                        return getSortOptions();
                      }}
                      defaultSelected={
                        searchForm.getField("sort_by") !== ""
                          ? [searchForm.getField("sort_by")]
                          : []
                      }
                      onChange={(v: any) => searchForm.setField("sort_by", v)}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="flex max-w-2xl h-full flex-col py-4 justify-center items-center">
              <div className="flex justify-between items-center">
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
              </div>
            </div>
          )}

          <div className="p-4">
            <ButtonBase
              variant="primary"
              type="submit"
              label="Search Properties"
              onClick={() => handleSubmit()}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-full",
                padding: "px-4 py-3",
              }}
              buttonPrefix={<SearchSvg2 />}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
